<template>
  <div>
    <DescriptionCard />
    <BarChart
      class="margin-bottom-16"
      :labels="barChartLabels"
      :series="barChartSeries"
      type="column"
      :titleText="firstTabTitle"
    />
    <ParvandehCard>
      <template slot="center-col" slot-scope="{ item }">
        <div class="font-size-12">
          <div class="font-weight-500 color-complementary-200">
            {{ generateOverallData(item, "caption") }}
          </div>
          <div class="color-complementary-300">
            {{ $lang.desirability }} :
            {{ generateOverallData(item, "desirability") }}
          </div>
          <div class="color-complementary-300">
            {{ $lang.risk }} : {{ generateOverallData(item, "risk") }}
          </div>
          <div class="color-complementary-300">
            {{ $lang.efficiency }} :
            {{ generateOverallData(item, "efficiency") }}
          </div>
        </div>
      </template>
      <template slot="left-col" slot-scope="{ item }">
        <TinyAverageBarBox
          :modalTitle="$lang.comparativeChartCenterExecute"
          :labels="generateRadarLabels(item)"
          :splineSeries="generateSplineSeries(item)"
          :averageBarLabels="generateRadarLabels(item)"
          :averageBarSeries="generateSplineSeries(item)"
          :radarLabels="generateRadarLabels(item)"
          :radarSeries="generateRadarSeries(item)"
          :radarYAxisRange="generateRadarYAxisSeries(item)"
        />
      </template>
      <template slot="body" slot-scope="{ item }">
        <CompetencyExerciseTable :data="item" />
      </template>
    </ParvandehCard>
  </div>
</template>

<script>
import { Bar as BarChart } from "@/components/charts";
import DescriptionCard from "../components/DescriptionCard.vue";
import ParvandehCard from "../components/parvandeh-card/ParvandehCard.vue";
import TinyAverageBarBox from "../components/TinyAverageBarBox.vue";
import CompetencyExerciseTable from "../components/CompetencyExerciseTable.vue";
import { computed, inject, onMounted } from "vue";
import { pathOr } from "ramda";
export default {
  components: {
    BarChart,
    DescriptionCard,
    ParvandehCard,
    TinyAverageBarBox,
    CompetencyExerciseTable,
  },
  setup() {
    const getWashupScores = inject("GET_WASHUP_SCORES_DATA");
    onMounted(() => getWashupScores());

    // overall data
    const generateOverallData = (item, key) => {
      const data = {
        caption: pathOr("", ["forecast", "caption"], item),
        desirability: pathOr(0, ["forecast", "desirability"], item),
        efficiency: pathOr(0, ["forecast", "efficiency"], item),
        risk: pathOr(0, ["forecast", "risk"], item),
      };
      return data[key];
    };
    // generate charts data
    const parvandehItems = inject("PARVANDEH_ITEMS");
    const barChartLabels = computed(() =>
      parvandehItems.value.map(({ fullName }) => fullName)
    );
    const barChartSeries = computed(() => {
      const data = parvandehItems.value.map((item) =>
        pathOr(0, ["forecast", "efficiency"], item)
      );

      return [
        {
          data,
          showInLegend: false,
          name: "بازده انتظاری",
        },
      ];
    });
    const generateRadarLabels = (item) => {
      const competencies = pathOr([], ["competencies"], item);
      return competencies.map(({ name }) => name);
    };
    const generateRadarSeries = (item) => {
      const competencies = pathOr([], ["competencies"], item);
      const scores = competencies.map(({ score }) => score);
      const scoreAverages = competencies.map(({ scoreAvg }) => scoreAvg);
      return [
        {
          type: "area",
          showInLegend: true,
          name: "میانگین",
          data: scoreAverages,
        },
        {
          type: "area",
          showInLegend: true,
          name: "شایستگی",
          data: scores,
        },
      ];
    };
    const generateRadarYAxisSeries = (item) => {
      const competencies = pathOr([], ["competencies"], item);
      return competencies.map((item, index) => index + 1);
    };
    const generateSplineSeries = (item) => {
      const competencies = pathOr([], ["competencies"], item);
      const scores = competencies.map(({ score }) => score);
      const scoreAverages = competencies.map(({ scoreAvg }) => scoreAvg);
      return [
        {
          type: "column",
          name: "شایستگی",
          data: scores,
        },
        {
          type: "spline",
          name: "میانگین این شاخص برای کل افراد",
          data: scoreAverages,
        },
      ];
    };

    const currentTab = inject("CURRENT_TAB");
    const firstTabTitle = computed(() =>
      pathOr(null, ["firstTabTitle"], currentTab.value)
    );

    // return data to be used in template
    return {
      barChartLabels,
      barChartSeries,
      generateOverallData,
      generateRadarLabels,
      generateRadarSeries,
      generateRadarYAxisSeries,
      generateSplineSeries,
      firstTabTitle,
    };
  },
};
</script>

<style>
.table-grid-row {
  display: grid;
  grid-template-rows: auto;
  align-items: start;
}
.table-body {
  min-width: 1200px;
}
</style>
